var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExternalLinkGrey = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23,
  height: 23,
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 13.0234L9.9751 14L21.6 2.34465V9.80147H23V0H13.1349L13.1139 1.40021H20.6438L9 13.0234Z",
  fill: "#3e5660"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 13V22H1V3H10",
  stroke: "#3e5660"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgExternalLinkGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/external-link-grey.661363c180b0919c8c9d69a054a3f2ec.svg";